module.exports = __webpack_public_path__ + "static/media/blank.84bf8e37.jpeg";